import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

import { ActionButton } from "components/ActionButton";
import { ButtonProgress } from "components/utility/ButtonProgress";

import { i18n } from "services/i18nService";
import { retrieveSettings } from "services/sosInventoryService/settings";
import { disconnectIntuitAccount } from "services/sosInventoryService/sosApi";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

export function DisconnectQbo() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const dispatch = useDispatch();
  const isLoading = useSelector(({ loading }) => loading.list);

  async function handleDisconnect() {
    dispatch(loadingIndicatorOn());
    setDialogOpen(false);
    const { success } = await disconnectIntuitAccount();
    if (success) {
      const message = i18n("quickBooks.DisconnectSuccess");
      dispatch(openAlert({ type: "success", message }));
      await retrieveSettings();
    }
    dispatch(loadingIndicatorOff());
  }

  return (
    <>
      <div style={{ position: "relative" }}>
        <ActionButton disabled={isLoading} onClick={() => setDialogOpen(true)}>
          {i18n("quickBooks.RemoveConnectionToQuickBooks")}
        </ActionButton>
        {isLoading && <ButtonProgress color="secondary" />}
      </div>
      {dialogOpen && (
        <ConfirmationDialog
          doDisconnect={handleDisconnect}
          onClose={() => setDialogOpen(false)}
        />
      )}
    </>
  );
}

function ConfirmationDialog(props) {
  const { doDisconnect, onClose } = props;
  const message = i18n("quickBooks.ConfirmationMessage");

  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{ inset: "0 0 40%" }}
    >
      <DialogContent sx={{ mt: 1 }}>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {i18n("button.Cancel")}
        </Button>
        <Button color="secondary" onClick={doDisconnect}>
          {i18n("button.OK")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
